import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect } from 'preact/hooks';
import { ScheduleXCalendar } from '@/components/calendar/ScheduleXCalendar';
import { useAIChatContextUpdater } from '@/hooks';
import { ChatLocations, ChatEntityTypes, ChatViewModes } from '@/constants/aiChat';
export function WebCalendarTab({ web, clientCompanyId }) {
    const { updateContext } = useAIChatContextUpdater();
    useEffect(() => {
        updateContext({
            workspaceId: web.WorkspaceId,
            campaignId: web.CampaignId,
            webId: web.Id,
            location: ChatLocations.WebCalendar,
            entityType: ChatEntityTypes.Web,
            entityId: web.Id,
            viewMode: ChatViewModes.View,
            availableFields: [],
            availableActions: ['CopyToClipboard'],
        });
    }, [web.WorkspaceId, web.CampaignId, web.Id, updateContext]);
    return (_jsx("div", { className: "-m-6", children: _jsx(ScheduleXCalendar, { clientCompanyId: clientCompanyId, workspaceId: web.WorkspaceId, webId: web.Id }) }));
}
